import React, { useEffect, useState } from "react";
import { useEmployeeData } from "../../context/EmployeeContext";
import api from "../../services/api";
import { resolveNotifRoute } from "../../utils/notifRouteResolver";
import "../../assets/styles/Employee/EmpNotificationsPage.css";

function EmpNotificationsPage({ onNavigate }) {
  const { empNotifications, refreshEmployeeData } = useEmployeeData();
  const [selected, setSelected] = useState(null);
  const [local, setLocal] = useState(empNotifications || []);

  useEffect(() => { setLocal(empNotifications || []); }, [empNotifications]);

  const items = local || [];
  const unreadCount = items.filter(n => n.unread || !n.is_read).length;

  const markAllRead = async () => {
    await api.markAllNotificationsRead().catch(() => {});
    setLocal(items.map(n => ({ ...n, is_read: true, unread: false })));
    if (refreshEmployeeData) refreshEmployeeData();
  };

  const handleClick = async (n) => {
    setSelected(n);
    if (n.id && !n.is_read) {
      await api.markNotificationRead(n.id).catch(() => {});
      setLocal(items.map(x => x.id === n.id ? { ...x, is_read: true, unread: false } : x));
      if (refreshEmployeeData) refreshEmployeeData();
    }
  };

  const handleOpen = (n) => {
    if (!onNavigate || !n) return;
    const tab = resolveNotifRoute(n, 'employee');
    onNavigate(tab);
  };

  const fmtTime = (t) => {
    if (!t) return '';
    try {
      const d = new Date(t); const diff = Math.floor((Date.now() - d) / 60000);
      if (diff < 1) return 'Just now';
      if (diff < 60) return `${diff}m ago`;
      if (diff < 1440) return `${Math.floor(diff / 60)}h ago`;
      return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    } catch { return ''; }
  };

  const typeColor = {
    chat:'#0ea5e9', leave:'#f59e0b', helpdesk:'#ef4444', payroll:'#16a34a',
    announcement:'#8b5cf6', announcements:'#8b5cf6', event:'#3b82f6', calendar:'#3b82f6',
    asset:'#d97706', offboarding:'#dc2626', onboarding:'#6366f1', general:'#94a3b8',
  };
  const getColor = (n) => typeColor[(n.type||'').toLowerCase()] || typeColor[(n.route||'').toLowerCase()] || '#6366f1';

  return (
    <div className="card animate-in">
      <div className="card-header">
        <div className="card-title">All Notifications</div>
        <div className="empnotificationspage-inline-1">
          <div className="card-subtitle">{unreadCount} unread</div>
          <button className="btn-o btn-s" onClick={markAllRead}>Mark all as read</button>
        </div>
      </div>
      <div className="card-body">
        {items.length === 0 ? (
          <div className="empnotificationspage-inline-2">No notifications yet</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {items.map((n, idx) => {
              const isUnread = n.unread || !n.is_read;
              const color = getColor(n);
              return (
                <div
                  key={n.id || idx}
                  className="notif-item empnotificationspage-dyn-1"
                  onClick={() => handleClick(n)}
                  style={{
                    '--empnotificationspage-1-background': selected?.id === n.id ? '#eef2ff' : isUnread ? '#fafbff' : 'transparent',
                    cursor: 'pointer', borderRadius: 8, padding: '10px 12px',
                    border: selected?.id === n.id ? '1px solid #c7d2fe' : '1px solid transparent',
                  }}
                >
                  <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                    <div style={{
                      width: 8, height: 8, borderRadius: '50%', marginTop: 5, flexShrink: 0,
                      background: isUnread ? color : '#e2e8f0',
                      boxShadow: isUnread ? `0 0 0 3px ${color}22` : 'none',
                    }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className={`notif-text${isUnread ? ' unread' : ''}`}
                        style={{ fontWeight: isUnread ? 600 : 400, color: isUnread ? '#0f172a' : '#64748b' }}>
                        {n.title || n.text || n.message || ''}
                      </div>
                      {n.body && (
                        <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 2 }}>{n.body}</div>
                      )}
                      <div style={{ display: 'flex', gap: 8, marginTop: 4, alignItems: 'center' }}>
                        <span style={{ fontSize: 10, color: '#94a3b8' }}>{fmtTime(n.created_at)}</span>
                        {isUnread && <span className="empnotificationspage-inline-3">NEW</span>}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Detail panel */}
        {selected && (
          <div className="empnotificationspage-inline-4" style={{ marginTop: 16 }}>
            <div className="empnotificationspage-inline-5">{selected.title || 'Notification'}</div>
            <div className="empnotificationspage-inline-6">{selected.body || selected.text || selected.message || '—'}</div>
            {onNavigate && (
              <button
                className="btn-o btn-s empnotificationspage-inline-7"
                onClick={() => handleOpen(selected)}
              >
                Open →
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default EmpNotificationsPage;
